export function GetBaseUrl() {
  console.log(process.env.NEXT_PUBLIC_BASE_URL);
  console.log(process.env.NODE_ENV);
  
  return process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_BASE_URL
    : "http://localhost:3000";
}
